<template>
  <div class="medical">
    <div class="container">
      <div class="titleNav">
        <a href="">我要下单</a> /
        <router-link to="/medical">医疗服务</router-link>
      </div>
      <!--搜索按钮-->
      <div class="container">
        <div class="search">
          <label for="">
            <input type="search" placeholder="请输入医院名称、医生" v-model="val">
            <img src="../../../assets/images/home/search.png" alt="">
          </label>
          <button @click="search">查询</button>
         <v-distpicker :placeholders="placeholders" :province="select.province" :city="select.city" :area="select.area" @selected="onSelected"></v-distpicker>
          <ul v-if="val">
            <li @click="search('doctor')">找医生：{{val}}</li>
            <li @click="search('hospital')">找医院：{{val}}</li>
          </ul>
        </div>

      </div>
      <!--医院简介-->
      <div class="intro">
        <ul class="list">
          <li class="item" @click="toHospital(item.id, index)" v-for="(item, index) in hospitalList" :key="index">
            <img :src="item.imgUuid" alt="">
            <div class="info">
              <h2 class="name">{{item.name}}</h2>
              <p class="rank">{{item.level}}</p>
              <p class="area">{{item.area}}</p>
              <p class="detail" v-html="item.introduction"></p>
            </div>
          </li>
        </ul>
      </div>
      <!--分页-->
      <div class="pagin">
        <pagination @pageSize="pageSize" :pageCount="pageCount"></pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from '../../../components/Pagination'
import {reqHospital, reqDoctor} from '../../../api'
import VDistpicker from 'v-distpicker'
export default {
  data() {
    return {
      val: '', // 搜素框内容
      hospitalList: [],
      pageCount: 0, // 总页数
/*      placeholders: {
        area: '全市',
      }, */

	placeholders: {
		province: '------- 省 --------',
		city: '--- 市 ---',
		area: '--- 区 ---',
	},
      select: { province: localStorage.getItem('province'), city: localStorage.getItem('cityName'), area: '' },
	  province:'',
	  city:'',
	  area:'',
    }
  },
  created() {
    this._reqHospital(1)
  },
  methods: {
    // 获取医院模块
    _reqHospital(val=1) {

      reqHospital({pageIndex:val,
	  provinceLike:this.province==''? localStorage.getItem('province'):this.province,
	  cityLike:this.city==''? localStorage.getItem('cityName'):this.city,
	  areaLike:this.area
	  }).then(res => {
        if(res.code === 200){
          this.pageCount = res.data.pageCount
          this.hospitalList = res.data.bussData
        }
      })
    },
    // 分页
    pageSize (val) {
      this._reqHospital(val)
    },
    // 去医院详情页面
    toHospital (hospitalId, index) {
      this.$store.dispatch('getHospitalInfo', this.hospitalList[index])
      this.$router.push({name: 'Detail', query: {hospitalId}})
    },
    // 搜索
    search (type) {

      if(type == 'doctor') {
        this.$router.push({name: 'Doctor', query: {nameLike: this.val,provinceLike:this.select.province,cityLike:this.select.city,
				areaLike:this.select.area}})
      } else {
        if(this.val) {
          reqHospital( {"nameLike": this.val,"pageIndex": "1","pageSize": "10"} ).then(res => {
            this.hospitalList = res.data.bussData
            this.pageCount = res.data.pageCount
            this.val = ''
          })
        } else {
          this._reqHospital()
        }
      }
    },
    // 根据区获取医院
     onSelected(data) {
		 this.province=data.province.value;
		  this.city=data.city.value;
		   this.area=data.area.value;
	   this._reqHospital(1,data.province.value,data.city.value, data.area.value)
     },
  },
  components: {
    Pagination,
    VDistpicker
  }
}
</script>

<style scoped lang="less" type="text/less">
.medical{
  .titleNav{
    margin:30px 0 41px;
  }
  /*搜索按钮*/
  .search{
    position: relative;
    display: flex;
    margin: 35px 0 51px;
    label{
      position: relative;
      display: block;
      width: 550px;
      height: 38px;
      margin-right:21px;
      line-height: 36px;
      border:1px solid #E1E1E1;
      input{
        width: 100%;
        height: 100%;
        font-size: 14px;
        color:#999;
        text-indent: 20px;
      }
      img{
        position: absolute;
        top: 0;
        right: 0;
      }
    }
    button{
      width: 115px;
      height: 38px;
      background: #61aee6;
      color: #fff;
      border:none;
      border-radius: 19px;
      font-size: 18px;
    }
    ul{
      position: absolute;
      top: 40px;
      background: #fff;
      border: 1px solid #e1e1e1;
      width: 487px;
      li{
        line-height: 30px;
        text-indent: 20px;
        cursor: pointer;
      }
    }
  }
  /*医院简介*/
  .intro{
    .list{
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .item{
        overflow: hidden;
        width: 557px;
        height: 220px;
        padding:20px;
        margin-bottom: 20px;
        box-sizing: border-box;
        box-shadow:0px 3px 9px 0px rgba(0, 0, 0, 0.09);
        cursor: pointer;
        img{
          float: left;
          display: block;
          width: 180px;
          height: 180px;
          margin-right: 20px;
          background: #ddd;
        }
        .name{
          margin-bottom: 12px;
          font-size: 18px;
          font-weight: 700;
        }
        .rank{
          margin-bottom: 19px;
          font-weight: 700;
          color:#61aee6;
        }
        .detail{
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 4;
          overflow: hidden;
          height: 93px;
          margin-top:10px;
          line-height: 24px;
        }
      }
    }
  }
  /*分页*/
  .pagin{
    margin:30px auto 50px;
    text-align: center;
  }
  .distpicker-address-wrapper{
    margin-left: 135px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Courier/Hospital/Medical.vue